(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroParallax {
    constructor(container) {
      this.container = container;
      this.mediaElements = container.querySelectorAll('.parallax-media .hero__media');
      this.contentWrapper = container.querySelector('.hero__content-wrapper[data-parallax-intensity]');

      this.onScroll = this.onScroll.bind(this);

      this.init();
    }

    init() {
      // Check if any element needs parallax or fixed
      if (this.mediaElements.length === 0 && !this.contentWrapper && this.container.dataset.fixedBackground !== 'true')
        return;

      // Use IntersectionObserver to only animate when in view
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', this.onScroll, { passive: true });
              this.onScroll();
            } else {
              window.removeEventListener('scroll', this.onScroll);
            }
          });
        },
        { threshold: 0 }
      );

      this.observer.observe(this.container);
    }

    onScroll() {
      const rect = this.container.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate progress (0 to 1) of the section passing through the viewport
      const progress = Math.max(0, Math.min(1, (windowHeight - rect.top) / (windowHeight + rect.height)));
      const centeredOffset = progress - 0.5;

      // Handle Fixed Background Mode (JS-driven for maximum smoothness)
      if (this.container.dataset.fixedBackground === 'true') {
        const offset = -rect.top;
        this.mediaElements.forEach((el) => {
          el.style.transform = `translate3d(0, ${offset}px, 0)`;
        });
      } else {
        // Handle Parallax Mode
        this.mediaElements.forEach((el) => {
          const intensity = parseFloat(el.parentElement.dataset.parallaxIntensity) || 0;
          const movement = centeredOffset * intensity; // Value ranges from -intensity/2 to +intensity/2
          el.style.transform = `translate3d(0, ${movement}%, 0)`;
        });
      }

      if (this.contentWrapper) {
        const intensity = parseFloat(this.contentWrapper.dataset.parallaxIntensity) || 0;
        const movement = centeredOffset * intensity * 1.5; // Content usually needs less movement
        this.contentWrapper.style.transform = `translate3d(0, ${movement}%, 0)`;
      }
    }
  }

  const initHeroParallax = () => {
    document.querySelectorAll('.hero[data-parallax="true"]').forEach((hero) => {
      // Prevent double initialization
      if (hero.dataset.parallaxInitialized) return;
      hero.dataset.parallaxInitialized = 'true';
      new HeroParallax(hero);
    });
  };

  document.addEventListener('DOMContentLoaded', initHeroParallax);
  document.addEventListener('shopify:section:load', initHeroParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
